export const adaptTextAreaSize = (e)=>{ 
    e.currentTarget.style.height = '0px'
    e.currentTarget.style.height = e.currentTarget.scrollHeight -20 + 'px'
}